window.productTagCache = window.productTagCache || {};

function getCartSurchargeConfig() {
  const config = window.cartSurcharge || {};
  return {
    variantId: Number(config.variantId || 0),
    text: config.text || '',
  };
}

async function getProductTags(handle) {
  if (!handle) return [];

  if (window.productTagCache[handle]) {
    return window.productTagCache[handle];
  }

  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return [];
    const product = await response.json();
    const tags = Array.isArray(product.tags) ? product.tags : [];
    window.productTagCache[handle] = tags;
    return tags;
  } catch (error) {
    console.error(`Could not fetch tags for ${handle}`, error);
    return [];
  }
}

async function syncCartSurcharge() {
  const surchargeConfig = getCartSurchargeConfig();
  const surchargeVariantId = surchargeConfig.variantId;
  const surchargeText = surchargeConfig.text;

  if (!surchargeVariantId) return null;

  const cartResponse = await fetch(`${routes.cart_url}.js`);
  const cart = await cartResponse.json();

  let hatProductCount = 0;
  let surchargeItems = [];

  for (const item of cart.items) {
    if (Number(item.id) === Number(surchargeVariantId) || Number(item.variant_id) === Number(surchargeVariantId)) {
      surchargeItems.push(item);
      continue;
    }

    if (item.properties && item.properties._is_addon === 'true') {
      continue;
    }

    const tags = await getProductTags(item.handle);
    const normalizedTags = Array.isArray(tags)
      ? tags.map((tag) => String(tag).trim().toLowerCase())
      : [];

    if (normalizedTags.includes('addon')) {
      continue;
    }

    if (normalizedTags.includes('hat product')) {
      hatProductCount += item.quantity;
    }
  }

  const shouldHaveSurcharge = hatProductCount > 0 && hatProductCount < 12;
  const surchargeQtyInCart = surchargeItems.reduce((sum, item) => sum + item.quantity, 0);

  if (shouldHaveSurcharge && surchargeQtyInCart === 1) return null;
  if (!shouldHaveSurcharge && surchargeQtyInCart === 0) return null;

  if (shouldHaveSurcharge) {
    if (surchargeQtyInCart > 0) {
      const updates = {};
      let first = true;

      surchargeItems.forEach((item) => {
        updates[item.key] = first ? 1 : 0;
        first = false;
      });

      await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ updates }),
      });

      return true;
    } else {
      await fetch(`${routes.cart_add_url}.js`, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [
            {
              id: surchargeVariantId,
              quantity: 1
            },
          ],
        }),
      });

      return true;
    }
  }

  const updates = {};
  surchargeItems.forEach((item) => {
    updates[item.key] = 0;
  });

  await fetch(`${routes.cart_update_url}`, {
    ...fetchConfig(),
    body: JSON.stringify({ updates }),
  });

  return true;
}
if (!customElements.get("product-form")) {
  window.latestCartResponse = null;
  // ===== Addon Flow Control =====
  window.isAddonFlow = false;
  window.latestCartResponse = null;
async function addLargeQuantity(originalFormData, sections, sectionsUrl) {
  const quantity = parseInt(originalFormData.get("quantity")) || 1;
  const maxPerRequest = 50;

  let remaining = quantity;
  let lastResponse = null;

  while (remaining > 0) {
    const chunk = remaining > maxPerRequest ? maxPerRequest : remaining;

    // Clone original formData properly
    const chunkData = new FormData();
    originalFormData.forEach((value, key) => {
      chunkData.append(key, value);
    });

    // Override quantity safely
    chunkData.set("quantity", chunk);

    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: chunkData,
    });

    if (!response.ok) {
      throw new Error("Add to cart failed");
    }

    lastResponse = await response.json();
    remaining -= chunk;
  }

  return lastResponse;
}
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        addLargeQuantity(
  formData,
  this.cart ? this.cart.getSectionsToRender().map((s) => s.id).join(",") : null,
  window.location.pathname
)
.then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (soldOutMessage) {
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
              }
              this.error = true;

              // Still refresh the cart drawer so partial adds are visible
              if (this.cart) {
                const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
                fetch(`${window.location.pathname}?sections=${sectionsToRender.join(',')}`)
                  .then((res) => res.json())
                  .then((sectionsData) => {
                    const cartResponse = { sections: sectionsData };
                    const pdpDiv = document.querySelector("product-info");
                    const isCustomPdp = pdpDiv && pdpDiv.classList.contains("custom-pdp");

                    if (isCustomPdp && !window.isAddonFlow) {
                      window.latestCartResponse = cartResponse;
                      document.dispatchEvent(new CustomEvent("openAddonDrawer"));
                    } else {
                      this.cart.renderContents(cartResponse);
                    }
                  })
                  .catch((err) => console.error("Cart refresh failed:", err));
              }
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
  "add:wait-for-subscribers",
);

const continueAfterSurcharge = () => {
  if (!this.error)
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "product-form",
      productVariantId: formData.get("id"),
      cartData: response,
    }).then(() => {
      CartPerformance.measureFromMarker(
        "add:wait-for-subscribers",
        startMarker,
      );
    });

  this.error = false;

  const pdpDiv = document.querySelector("product-info");
  const isCustomPdp = pdpDiv && pdpDiv.classList.contains("custom-pdp");

  if (isCustomPdp && !window.isAddonFlow) {
    window.latestCartResponse = response;
    document.dispatchEvent(new CustomEvent("openAddonDrawer"));
    return;
  }

  const quickAddModal = this.closest("quick-add-modal");
  if (quickAddModal) {
    document.body.addEventListener(
      "modalClosed",
      () => {
        setTimeout(() => {
          CartPerformance.measure(
            "add:paint-updated-sections",
            () => { this.cart.renderContents(response); },
          );
        });
      },
      { once: true },
    );
    quickAddModal.hide(true);
  } else {
    CartPerformance.measure("add:paint-updated-sections", () => {
      this.cart.renderContents(response);
    });
  }
};

syncCartSurcharge()
  .catch((err) => {
    console.error("Surcharge sync failed:", err);
  })
  .finally(() => {
    continueAfterSurcharge();
  });

return;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        // NEW: check main PDP div instead
                        const pdpDiv = document.querySelector("product-info");
                        const isCustomPdp =
                          pdpDiv && pdpDiv.classList.contains("custom-pdp");

                        // MAIN PDP PRODUCT
                        if (isCustomPdp && !window.isAddonFlow) {
                          // Save response for later
                          window.latestCartResponse = response;

                          // Open Addon Drawer Instead
                          document.dispatchEvent(
                            new CustomEvent("openAddonDrawer"),
                          );
                        } else {
                          // Normal behavior (addons OR other pages)
                          this.cart.renderContents(response);
                        }
                      },
                    );
                    // CartPerformance.measure("add:paint-updated-sections", () => {
                    //   this.cart.renderContents(response);
                    // });
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                // NEW: check main PDP div instead
                const pdpDiv = document.querySelector("product-info");
                const isCustomPdp =
                  pdpDiv && pdpDiv.classList.contains("custom-pdp");

                // MAIN PDP PRODUCT
                if (isCustomPdp && !window.isAddonFlow) {
                  // Save response for later
                  window.latestCartResponse = response;

                  // Open Addon Drawer Instead
                  document.dispatchEvent(new CustomEvent("openAddonDrawer"));
                } else {
                  // Normal behavior (addons OR other pages)
                  this.cart.renderContents(response);
                }
              });
              // CartPerformance.measure("add:paint-updated-sections", () => {
              //   this.cart.renderContents(response);
              // });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            window.isAddonFlow = false;
            // document.dispatchEvent(new CustomEvent('closeddonDrawer'));
            this.submitButton.classList.remove("loading");

            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // NEW: Scroll to the error message smoothly when it appears
          this.errorMessageWrapper.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
// ===== Detect Addon Form Submit =====
document.addEventListener("submit", function (e) {
  if (e.target.closest(".addon-product-card")) {
    window.isAddonFlow = true;
  }
});

document.querySelector("#addon-form").addEventListener("submit", function (e) {
  e.preventDefault();

  const form = e.target;
  const activeAddons = [];

  // collect addons that have qty > 0
  form.querySelectorAll(".addon-option").forEach(option => {
    const qtyInput = option.querySelector(".addon-quantity");
    const idInput = option.querySelector(".addon-variant-id");
    const qty = parseInt(qtyInput?.value || 0);
    const id = idInput?.value;
    if (qty > 0 && id) {
      // collect properties
      const properties = {};
      option.querySelectorAll("input[name*='[properties]']").forEach(inp => {
        const match = inp.name.match(/\[properties\]\[(.+)\]/);
        if (match) properties[match[1]] = inp.value;
      });
      activeAddons.push({ id, quantity: qty, properties });
    }
  });

  const addonDrawer = document.getElementById("addon-drawer");

  if (activeAddons.length === 0) {
    // no addons selected — just go to cart
    if (addonDrawer) addonDrawer.classList.remove("active");
    window.location.href = window.routes ? window.routes.cart_url : '/cart';
    return;
  }

  // add addons then redirect
  fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: activeAddons })
  })
  .then(r => r.json())
  .then(() => {
    if (addonDrawer) addonDrawer.classList.remove("active");
    window.location.href = window.routes ? window.routes.cart_url : '/cart';
  })
  .catch(err => {
    console.error('Failed to add addons:', err);
    if (addonDrawer) addonDrawer.classList.remove("active");
    window.location.href = window.routes ? window.routes.cart_url : '/cart';
  });
});
